import { render, staticRenderFns } from "./BigCommerceUtilities.vue?vue&type=template&id=6e28052e"
import script from "./BigCommerceUtilities.vue?vue&type=script&lang=js"
export * from "./BigCommerceUtilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports